<div>
    <div aria-labelledby="contact-tab" class="tab-pane fade" id="img" role="tabpanel">
        <div class="container-fluid">
            <div class="content-block">
                <div class="row align-content-center">

                    <div class="col-lg-10">
                        <div class="empty-data blue my-0">
                            <p>
                                Upload banner image of your company.
                            </p>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <a
                                @click.prevent="onUploadBannerImage('image')"
                                class="btn btn-sm add-btn"
                                data-toggle="modal"
                                href="#"
                        ><i class="fas fa-plus"></i>
                            Browse
                        </a>
                        <UploadFile
                                :checkTitle="vars.postdata.checkTitle"
                                :limitdata="vars.limitdata"
                                :postdata="vars.postdata"
                                :shouldfileupload="ui.status.fileUpload"
                                :titles="vars.titles"
                                @closeUploadModal="closeUploadModal"
                                @documentUploaded="documentUploaded"
                                v-if="ui.status.fileUpload"
                        ></UploadFile>
                    </div>
                </div>
                <div class="profile-bg">
                    <img :src="item.accountData.banner_path" alt="">
                </div>
                <div class="row align-content-center">

                    <div class="col-lg-10">
                        <div class="empty-data blue my-0">
                            <p>
                                Upload logo of your company.
                            </p>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <a
                                @click.prevent="onUploadLogo('image')"
                                class="btn btn-sm add-btn"
                                data-toggle="modal"
                                href="#"
                        ><i class="fas fa-plus"></i>
                            Browse
                        </a>
                        <UploadFile :checkTitle="vars.postdata.checkTitle" :limitdata="vars.limitdata"
                                    :postdata="vars.postdata" :shouldfileupload="ui.status.fileUpload" :titles="vars.titles"
                                    @closeUploadModal="closeUploadModal" @documentUploaded="documentUploaded" v-if="ui.status.fileUpload"></UploadFile>
                    </div>
                </div>
                <!--<div :key="'account'+index" class="user-image" v-for="(account, index) in activeUser.accounts"-->
                <!--v-if="activeUser.accounts">-->
                <!--<img :src="account.logo_path" alt="" v-if="account.logo_path"/>-->
                <!--<img alt="" src="img/user.jpg" v-else/>-->
                <!--</div>-->
                <div class="profile-bg">
                    <img :src="item.accountData.logo_path" alt="">
                </div>

                <div class="content-block">
                    <div class="row">

                    </div>
                </div>
                <!-- Delete Modal -->
                <div class="modal-wrap">
                    <div
                            aria-labelledby="exampleModalLabel"
                            class="modal fade show"
                            id="deleteTrekImage"
                            role="dialog"
                            tabindex="-1"
                    >
                        <div class="modal-dialog modal-dialog-centered" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Delete Image</h5>
                                    <button
                                            aria-label="Close"
                                            class="close"
                                            data-dismiss="modal"
                                            type="button"
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div class="error-list" v-if="ui.error.errors">
                                    <ul class="error-msg">
                                        <li :key="x" v-for="(error,x) in ui.error.errors">
                                            {{ error }}
                                        </li>
                                    </ul>
                                </div>
                                <div class="modal-body">
                                    <p>
                                        Are you sure you want to delete this ?
                                    </p>
                                </div>

                                <div class="modal-footer">
                                    <button
                                            @click="deleteImage()"
                                            class="btn default-btn"
                                            type="button"
                                    >
                                        Ok
                                    </button>
                                    <button
                                            @click.prevent="hidedeleteModal"
                                            aria-label="Close"
                                            class="btn default-btn cancel"
                                            type="button"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
